import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@mui/icons-material/WbSunny';
import DarkIcon from '@mui/icons-material/Brightness3';
import { customLightTheme, customDarkTheme } from '../../theme/themes';

const lightThemeExtension = ThemeBlueprint.make({
  name: 'custom-light',
  params: {
    theme: {
      id: 'custom-light',
      title: 'Light',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={customLightTheme} children={children} />
      ),
    },
  },
});

const darkThemeExtension = ThemeBlueprint.make({
  name: 'custom-dark',
  params: {
    theme: {
      id: 'custom-dark',
      title: 'Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={customDarkTheme} children={children} />
      ),
    },
  },
});

// Light is the default theme on first visit. This is seeded into
// localStorage['theme'] in packages/app/src/index.tsx, before the app boots,
// so it also applies to the sign-in page (which renders before any in-app
// React wrapper). Users can still switch to dark from Settings > Appearance.
export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [lightThemeExtension, darkThemeExtension],
});
